import { render, staticRenderFns } from "./DefectiveChipInfo.vue?vue&type=template&id=039bae04&scoped=true&"
import script from "./DefectiveChipInfo.vue?vue&type=script&lang=js&"
export * from "./DefectiveChipInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039bae04",
  null
  
)

export default component.exports